module.exports = __webpack_public_path__ + "img/ca_icon.8998dc48.png";